<template>
  <div class="invoice-subject">
    <el-table :data="invoiceSubjectData" border>
      <el-table-column label="CNPJ" prop="cnpj" min-width="160" />
      <el-table-column prop="ie" label="IE" min-width="160" />
      <el-table-column :label="$t('collectionCenter.stateZT')" prop="status" min-width="160">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="success" size="mini">{{ $t('collectionCenter.enable') }}</el-tag>
          <el-tag v-else-if="scope.row.status === 0" type="danger" size="mini">{{ $t('collectionCenter.disable') }}</el-tag>
          <el-tag v-else type="info" size="mini">{{ $t('collectionCenter.Stored') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('collectionCenter.businessT')" prop="businessType" min-width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.businessType === 0">{{ $t('collectionCenter.expressDelivery') }}</div>
          <div v-if="scope.row.businessType === 1">{{ $t('collectionCenter.lanshou') }}</div>
          <div v-if="scope.row.businessType === 2">{{ $t('basicData.StockingAndPickup') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('GlobalSetObj.serviceTypes')" prop="tpServ" min-width="160" />
      <el-table-column :label="$t('GlobalSetObj.zipCode')" prop="zipcode" min-width="160" />
      <el-table-column :label="$t('customerManagements.CountryCode')" prop="countryCode" min-width="160" />
      <el-table-column :label="$t('GlobalSetObj.Estado')" prop="state" min-width="160" />
      <el-table-column :label="$t('collectionCenter.city')" prop="city" min-width="160" />
      <el-table-column :label="$t('collectionCenter.RecipientStreet')" prop="street" min-width="160" />
      <el-table-column :label="$t('placeOrder.HouseNumber')" prop="number" min-width="160" />
    </el-table>
  </div>
</template>
<script>
import { getInvoiceSubject } from '@/api/customer';

export default {
  name: 'InvoiceSubject',
  props: {
    customerType: {
      type: Object,
      default() {
        return {
          id: '', // 客户ID
          customerAlias: '', // 客户别名
          username: '',
          type: 'add'
        };
      }
    }
  },
  data() {
    return {
      invoiceSubjectData: []
    };
  },
  mounted() {
    this.getInvoiceSubject();
  },
  methods: {
    // 获取发票主体信息
    getInvoiceSubject() {
      const param = {
        customerId: this.customerType.id,
        customerName: this.customerType.username
      };
      getInvoiceSubject(param).then(res => {
        if (res.code === 200) {
          this.invoiceSubjectData = res.data;
        }
      });
    }
  }
};
</script>

<style>
.invoice-subject .el-form-item__content {
  line-height: 20px;
}
</style>
